import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueDragscroll from 'vue-dragscroll'
import VueVideoPlayer from 'vue-video-player'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import 'normalize.css'
import 'swiper/dist/css/swiper.css'
import 'video.js/dist/video-js.css'

Vue.use(VueAwesomeSwiper)
Vue.use(VueVideoPlayer)
Vue.use(VueDragscroll)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
